module.exports = __webpack_public_path__ + "img/music_open.25714490.png";